<template>
  <div class="select-friends-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="$t('select_friends.page_title')"
      left-arrow
      @click-left="goBack"
      fixed
      placeholder
    />

    <!-- 标签栏 -->
    <van-tabs v-model="activeTab" @change="onTabChange" color="#FF69B4" class="tab-bar">
      <van-tab :title="$t('select_friends.tab_follow')" name="follow"></van-tab>
      <van-tab :title="$t('select_friends.tab_fans')" name="fans"></van-tab>
    </van-tabs>

    <!-- 搜索栏 -->
    <van-search
      v-model="searchValue"
      :placeholder="$t('select_friends.search_placeholder')"
      show-action
      shape="round"
      @search="onSearch"
      @cancel="onCancel"
    />

    <!-- 用户列表 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('select_friends.no_more')"
        @load="onLoad"
      >
        <div 
          class="user-item" 
          v-for="user in userList" 
          :key="user.id"
        >
          <div class="user-info">
            <img :src="user.head_image" class="user-avatar" />
            <div class="user-detail">
              <div class="user-name">
                <span class="nick-name">{{ user.nick_name }}</span>
                <img v-if="user.level_icon" :src="user.level_icon" class="level-icon" />
                <img v-if="user.country_flag" :src="user.country_flag" class="country-flag" />
              </div>
              <div class="user-age">
                <div class="sex-age-badge">
                  <img :src="user.sex == 1 ? require('@/assets/img/sex1-1.png') : require('@/assets/img/sex2-1.png')" class="sex-icon" />
                  <span class="age-overlay">{{ user.age }}</span>
                </div>
              </div>
              <div class="user-id">{{ $t('select_friends.user_id_label') }}{{ user.id }}</div>
            </div>
          </div>
          <van-button 
            size="small" 
            :round="true"
            color="#e6e6fe"
            class="gift-btn"
            @click="onShare(user)"
            :icon="require('@/assets/img/mall/mall_close.png')"
          >
          </van-button>
        </div>

        <!-- 空状态 -->
        <van-empty v-if="userList.length === 0 && !loading" :description="$t('select_friends.empty_data')" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"

export default {
  name: 'SelectFriends',
  data() {
    return {
      activeTab: 'fans',
      searchValue: '',
      userList: [],
      // 从商城页面传递过来的商品信息
      productInfo: null,
      mallQuery: null,
      // 分页相关
      loading: false,
      finished: false,
      isLoading: false,
      currentPage: 1,
      pageSize: 20
    }
  },
  created() {
    // 获取路由参数
    try {
      // product 可能是字符串，需要解析
      const productStr = this.$route.query.product
      this.productInfo = typeof productStr === 'string' ? JSON.parse(productStr) : productStr
    } catch (e) {
      console.error(this.$t('select_friends.parse_product_error'), e)
      this.productInfo = null
    }
    
    this.mallQuery = {
      uid: this.$route.query.uid,
      token: this.$route.query.token
    }
    
    // 加载用户列表
    this.loadUserList()
  },
  methods: {
    loadUserList(loadMore = false) {
      const { uid, token } = this.mallQuery
      const type = this.activeTab === 'follow' ? 'follow' : 'fans'
      
      if (!loadMore) {
        this.currentPage = 1
        this.userList = []
        this.finished = false
      }

      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=select_friends", {
        params: {
          user_id: uid,
          token: token,
          type: type,
          keyword: this.searchValue,
          page: this.currentPage,
          page_size: this.pageSize
        }
      }).then(res => {
        if (res.data.status === 1) {
          const newList = res.data.data.list || []
          if (loadMore) {
            this.userList = this.userList.concat(newList)
          } else {
            this.userList = newList
          }
          
          // 判断是否还有更多数据
          if (newList.length < this.pageSize) {
            this.finished = true
          }
        } else {
          this.$toast.fail(res.data.error)
          this.finished = true
        }
      }).catch(err => {
        console.error('Failed to load user list:', err)
        this.$toast.fail(this.$t('select_friends.load_failed'))
        this.finished = true
      }).finally(() => {
        this.loading = false
        this.isLoading = false
      })
    },
    onRefresh() {
      this.onLoad(true)
    },
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.currentPage = 1
        this.userList = []
        this.finished = false
      }
      
      this.loading = true
      this.loadUserList(isRefresh)
      
      if (!isRefresh && !this.finished) {
        this.currentPage++
      }
    },
    onTabChange() {
      this.finished = false
      this.currentPage = 1
      this.loadUserList()
    },
    onSearch() {
      this.finished = false
      this.currentPage = 1
      this.loadUserList()
    },
    onCancel() {
      this.searchValue = ''
      this.finished = false
      this.currentPage = 1
      this.loadUserList()
    },
    onShare(user) {
      if (!this.productInfo) {
        this.goBackWithGift()
        return
      }

      const { uid, token } = this.mallQuery
      axios.get(this.baseUrlApi + this.baseUrlPath + '?ctl=prop_mall&act=send_mall_share_message', {
        params: {
          user_id: uid,
          token: token,
          receiver_id: user.id,
          product_name: this.productInfo.name || '',
          product_img: this.productInfo.img || '',
          product_type: this.productInfo.type || 0,
          product_id: this.productInfo.id || 0
        }
      }).then(res => {
         Toast(res.data.error)
        if (res.data.status === 1) {
          // 发送成功，将分享对象信息写入 productInfo
          this.productInfo = {
            ...this.productInfo
          }
        }
      }).catch(err => {
        console.error('Failed to send share message:', err)
         Toast(err.message)
      })
    },
    goBack() {
      // 返回商城页面
      this.goBackWithGift()
    },
    goBackWithGift() {
      // 返回商城页面,并携带参数表示需要打开详情弹框
      this.$router.replace({
        path: '/mall',
        query: {
          ...this.mallQuery,
          openDetail: '1',
          product: JSON.stringify(this.productInfo)
        }
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/select_share_friends.vue